module.exports = __webpack_public_path__ + "static/media/ball.b89c43a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Fixtures/Teams/backupImage/ball.png
// module id = 1268
// module chunks = 0